<ng-container *ngIf="journey">
    <app-flight-segment
        *ngFor="let flight of journey.flights; let i = index; let l = last"
        [flight]="flight" [vuelta]="l"
    ></app-flight-segment>
</ng-container>
